/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerGoCampaign_Precincts.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for GoCampaign Precincts
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Sunday, October 27, 2019 - 01:52:36 PM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      10/27/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    PRECINCT_LIST_CONTAINER_LOADED,
    PRECINCT_LIST_CONTAINER_UNLOADED,
    PRECINCT_LIST_TABLE_LOADED,
    PRECINCT_LIST_TABLE_UNLOADED,

    PRECINCT_SELECT_ROW,
    PRECINCT_ADD,
    PRECINCT_EDIT,
    PRECINCT_DELETE,
    PRECINCT_OPEN_WARNING,
    PRECINCT_CLOSE_WARNING,
    PRECINCT_DELETE_DISABLE,

    PRECINCT_EDIT_CONTAINER_LOADED,
    PRECINCT_EDIT_CONTAINER_UNLOADED,
    PRECINCT_EDIT_FORM_LOADED,
    PRECINCT_EDIT_FORM_UNLOADED,
    PRECINCT_EDIT_DATA_LOAD,
    PRECINCT_EDIT_CONTAINER_SUBMIT,
    PRECINCT_EDIT_CONTAINER_CANCEL,

    PRECINCT_UPDATE_VALUE
} from '../constants/actionTypeGoCampaign_Precincts';

const defaultState = {
    refreshList: false,
    danger: false,
    gocampaignprecinctid: 0,
    countryid: 0,
    country: '',
    stateid: 0,
    state: '',
    gc_countyid: 0,
    county: '',
    precinctgroupid: 0,
    precinctgroup: '',
    precinctcode: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case PRECINCT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                gocampaignprecincts: action.payload[0] ? action.payload[0].records : [],
                countries: action.payload[1] ? action.payload[1].records : [],
                states: action.payload[2] ? action.payload[2].records : [],
                counties: action.payload[3] ? action.payload[3].records : [],
                precinctgroups: action.payload[4] ? action.payload[4].records : []
            }
        case PRECINCT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case PRECINCT_SELECT_ROW:
            return {
                ...state,
                gocampaignprecinctid: action.id
            }
        case PRECINCT_ADD:
            return {
                ...state
            }
        case PRECINCT_EDIT:
            return {
                ...state,
                gocampaignprecinctid: action.id
            }
        case PRECINCT_DELETE:
            return {
                ...state,
                gocampaignprecinctid: null
            }
        case PRECINCT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case PRECINCT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case PRECINCT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case PRECINCT_EDIT_CONTAINER_LOADED:
        case PRECINCT_EDIT_DATA_LOAD:
            return {
                ...state,
                gocampaignprecinctid: action.payload[0] ? action.payload[0].precinctid : 0,
                countryid: action.payload[0] ? action.payload[0].countryid : 0,
                country: action.payload[1] ? action.payload[1].name : action.payload[0] ? action.payload[0].country : '',
                stateid: action.payload[0] ? action.payload[0].stateid : 0,
                state: action.payload[2] ? action.payload[2].name : action.payload[0] ? action.payload[0].state : '',
                gc_countyid: action.payload[0] ? action.payload[0].gc_countyid : 0,
                county: action.payload[3] ? action.payload[3].name : action.payload[0] ? action.payload[0].county : '',
                precinctgroupid: action.payload[0] ? action.payload[0].precinctgroupid : 0,
                precinctgroup: action.payload[4] ? action.payload[4].name : action.payload[0] ? action.payload[0].precinctgroup : '',
                precinctcode: action.payload[0] ? action.payload[0].precinctcode : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case PRECINCT_UPDATE_VALUE:
            return {
                ...state,
                [action.key]: action.value
            }
        case PRECINCT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case PRECINCT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case PRECINCT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case PRECINCT_LIST_CONTAINER_UNLOADED:
        case PRECINCT_LIST_TABLE_UNLOADED:
        case PRECINCT_EDIT_CONTAINER_UNLOADED:
        case PRECINCT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerGoCampaign_Precincts.js